import React from "react";

import { ROUTE_CALENDAR } from "../../../config/lang";
import { translate } from "../../../util/util";
import { dayMonthLabel, nthOfMonth } from "./dateUtils";

const ORDINAL_KEY = { 1: "ord_first", 2: "ord_second", 3: "ord_third", 4: "ord_fourth", 5: "ord_fifth" };

const fill = (template, vars) => (template || "").replace(/\{(\w+)\}/g, (_, k) => vars[k] ?? "");

// Shown after a point is dropped on a day. Lets the supervisor choose how the stop recurs:
//   every    → the base weekly series for that weekday
//   nth      → only the Nth occurrence of that weekday each month
//   date     → only that exact calendar date (one-off)
export default function ScopeMenu({ date, point, lang, onChoose, onCancel }) {
  const localeWeekday = new Intl.DateTimeFormat(
    { uk: "uk", en: "en-GB", hy: "hy", ka: "ka" }[lang] || "en-GB",
    { weekday: "long" }
  ).format(date);
  const nth = nthOfMonth(date);
  const ordinal = translate(ROUTE_CALENDAR, ORDINAL_KEY[nth], lang);
  const dateStr = dayMonthLabel(date, lang);

  const options = [
    { type: "every", label: fill(translate(ROUTE_CALENDAR, "scope_every", lang), { day: localeWeekday }), icon: "event_repeat" },
    { type: "nth", label: fill(translate(ROUTE_CALENDAR, "scope_nth", lang), { ord: ordinal, day: localeWeekday }), icon: "calendar_month" },
    { type: "date", label: fill(translate(ROUTE_CALENDAR, "scope_date", lang), { date: dateStr }), icon: "today" },
  ];

  return (
    <div className="rc-scope-backdrop" onClick={onCancel}>
      <div className="rc-scope-menu" onClick={e => e.stopPropagation()}>
        <div className="rc-scope-header">
          <span className="rc-scope-title">{translate(ROUTE_CALENDAR, "scope_title", lang)}</span>
          <span className="rc-scope-point">{point?.name}</span>
        </div>
        {options.map(opt => (
          <button key={opt.type} className="rc-scope-option" onClick={() => onChoose(opt.type)}>
            <span className="material-symbols-outlined">{opt.icon}</span>
            <span>{opt.label}</span>
          </button>
        ))}
        <button className="rc-scope-cancel" onClick={onCancel}>
          {translate(ROUTE_CALENDAR, "cancel", lang)}
        </button>
      </div>
    </div>
  );
}
